import { observable, action, makeObservable } from 'mobx';

export class UserStore {
  isAuthenticated: boolean | null = null;

  user: any;

  constructor() {
    makeObservable(this, {
      isAuthenticated: observable,
      user: observable,
      setUser: action.bound,
      setUserAuthenticated: action.bound,
    });
  }

  setUser = (value: any): void => {
    this.user = value;
  };

  setUserAuthenticated = (value: boolean): void => {
    this.isAuthenticated = value;
  };
}
